//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/dealers/views/main/lan/es';
import createEditDealer from 'Modules/dealers/views/.components/createEditDealer/lan/es';
import overview from 'Modules/dealers/views/overview/lan/es';
import dealersTab from 'Modules/dealers/views/.components/tab/lan/es';
import billingAccountsTab from 'Modules/dealers/views/.components/billingAccountsTab/lan/es';
import deleteBillingAccount from 'Modules/dealers/views/.components/deleteBillingAccount/lan/es';
import createEditBillingAccount from 'Modules/dealers/views/.components/createEditBillingAccount/lan/es';
import assignBillingAccount from 'Modules/dealers/views/.components/assignBillingAccount/lan/es';
import webHooksTab from 'Modules/dealers/views/.components/webHooksTab/lan/es';
import dealerAlertLogsTab from 'Modules/dealers/views/.components/dealerAlertLogsTab/lan/es';
import createEditWebHook from 'Modules/dealers/views/.components/createEditWebHook/lan/es';
import deleteWebHook from 'Modules/dealers/views/.components/deleteWebHook/lan/es';
import resendDealerAlertLog from 'Modules/dealers/views/.components/resendDealerAlertLog/lan/es';


locales = {
    ...locales,
    ...main,
    ...createEditDealer,
    ...overview,
    ...dealersTab,
    ...billingAccountsTab,
    ...deleteBillingAccount,
    ...createEditBillingAccount,
    ...assignBillingAccount,
    ...webHooksTab,
    ...dealerAlertLogsTab,
    ...createEditWebHook,
    ...deleteWebHook,
    ...resendDealerAlertLog
};


export default locales;